import { OpenAPI } from './schema';
import { getAccessToken } from '../service';
import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { REACT_APP_BASE_URL } from '../urlConfig';

const useMockedData = false;

export const setupOpenAPI = (): void => {
  OpenAPI.BASE = REACT_APP_BASE_URL ?? '/';
  OpenAPI.WITH_CREDENTIALS = true;
  // OpenAPI.TOKEN = async _options =>
  //   await getAccessToken(true, {
  //     scopes: [`User.Read`]
  //   }).then(token => token);
  // OpenAPI.HEADERS = async _options =>
  //   await getAccessToken(true, {
  //     scopes: [`User.Read`]
  //   }).then(token => ({
  //     Msgraphtoken: token
  //   }));
};

type ApiCallFunction<
  FilterType extends Record<string, unknown> & {
    authorization: string;
  },
  FunctionReturnType
> = (filterType: FilterType) => Promise<FunctionReturnType>;

export const useDataLoader = <
  FunctionReturnType,
  FilterType extends Record<string, unknown> & {
    authorization: string;
  }
>(
  dataLoadingPromise: ApiCallFunction<FilterType, FunctionReturnType>,
  mockedData?: FunctionReturnType
): {
  isLoading: boolean;
  error: boolean;
  requestData: (filterType: Omit<FilterType, 'authorization'>) => Promise<null | FunctionReturnType>;
} => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState(false);
  const requestData = async (loadFilter: Omit<FilterType, 'authorization'>): Promise<FunctionReturnType | null> =>
    await getAccessToken(true).then(async authorization => {
      setIsLoading(true);
      setError(false);
      // @ts-expect-error
      return await dataLoadingPromise({
        ...loadFilter,
        authorization: `Bearer ${authorization}`
      })
        .then(data => data)
        .catch(reason => {
          setError(true);
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          if (useMockedData && mockedData) {
            return mockedData;
          } else {
            throw reason;
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    });

  return {
    error,
    isLoading,
    requestData
  };
};

export const useDataCachedLoader = <
  FunctionReturnType,
  FilterType extends Record<string, unknown> & {
    authorization: string;
  }
>(
  dataLoadingPromise: ApiCallFunction<FilterType, FunctionReturnType>,
  filter: Omit<FilterType, 'authorization'>,
  mockedData?: FunctionReturnType
): {
  isLoading: boolean;
  error: boolean;
  data?: FunctionReturnType;
  requestData: (filterType: Omit<FilterType, 'authorization'>) => Promise<null | FunctionReturnType>;
} => {
  const { isLoading, error, requestData } = useDataLoader<FunctionReturnType, FilterType>(dataLoadingPromise, mockedData);
  const [dataLoadFilter, setDataLoadFilter] = useState<typeof filter>();
  const [data, setData] = useState<FunctionReturnType>();

  useEffect(() => {
    if (!isEqual(dataLoadFilter, filter)) {
      setDataLoadFilter(filter);
    }
  }, [filter]);

  useEffect(() => {
    if (dataLoadFilter != null) {
      void requestData(dataLoadFilter).then(responseData => setData(responseData ?? undefined));
    }
  }, [dataLoadFilter]);

  return {
    isLoading,
    error,
    data,
    requestData
  };
};
